import './App.css';
import './styles/branding.css';
import './styles/photos.css';
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider, useAuth } from './context/Auth';
import { Loading } from './components/shared';
import Layout from './components/Layout';
import AuthPage, { AuthCallback } from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import Roster from './pages/Roster';
import Templates, { TemplateWizard } from './pages/Templates';
import Passport, { PublicPassport } from './pages/Passport';
import Parent, { Join } from './pages/Parent';
import Workspace from './pages/Workspace';
import ParentProfile from './pages/ParentProfile';
import PlayerPassport from './pages/PlayerPassport';
import PlayerInvitation from './pages/PlayerInvitation';
import CoachInvite from './pages/CoachInvite';

function Protected({ role }) {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === 'parent' ? '/parent' : '/dashboard'} replace />;
  return <Outlet />;
}
function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  return <Navigate to={user ? user.role === 'parent' ? '/parent' : '/dashboard' : '/login'} replace />;
}
function AppRouter() {
  const location = useLocation();
  if (location.hash.includes('session_id=')) return <AuthCallback />;
  return <Routes>
    <Route path="/" element={<HomeRedirect />} />
    <Route path="/login" element={<AuthPage />} />
    <Route path="/p/:slug" element={<PublicPassport />} />
    <Route path="/join/:slug" element={<Join />} />
    <Route path="/player-passport/invitations/:token" element={<PlayerInvitation />} />
    <Route path="/coach-invite/:token" element={<CoachInvite />} />
    <Route element={<Protected />}><Route element={<Layout />}>
      <Route element={<Protected role="trainer" />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/athletes" element={<Roster />} />
        <Route path="/athletes/:id" element={<Workspace />} />
        <Route path="/evaluations" element={<Templates key="eval" kind="evaluation" />} />
        <Route path="/evaluations/new" element={<TemplateWizard kind="evaluation" />} />
        <Route path="/evaluations/:id/edit" element={<TemplateWizard kind="evaluation" />} />
        <Route path="/drills" element={<Templates key="drill" kind="drill" />} />
        <Route path="/drills/new" element={<TemplateWizard kind="drill" />} />
        <Route path="/drills/:id/edit" element={<TemplateWizard kind="drill" />} />
        <Route path="/passport" element={<Passport />} />
      </Route>
      <Route element={<Protected role="parent" />}>
        <Route path="/parent" element={<Parent />} />
        <Route path="/parent/profile" element={<ParentProfile />} />
        <Route path="/parent/athletes/:id" element={<Workspace />} />
        <Route path="/parent/athletes/:id/passport" element={<PlayerPassport />} />
      </Route>
    </Route></Route>
    <Route path="*" element={<HomeRedirect />} />
  </Routes>;
}
export default function App() {
  return <BrowserRouter><AuthProvider><AppRouter /><Toaster theme="dark" richColors position="bottom-right" closeButton /></AuthProvider></BrowserRouter>;
}